import React from 'react';
import './DeviceSelector.css';

const DeviceSelector = ({ devices, selectedDevice, onSelectDevice, loading }) => {
  return (
    <div className="device-selector">
      <label htmlFor="device-select">Select Device:</label>
      <select
        id="device-select"
        name="device"
        value={selectedDevice || ''}
        onChange={(e) => onSelectDevice(e.target.value)}
        disabled={loading || devices.length === 0}
      >
        <option value="">-- Choose a device --</option>
        {devices.map((device) => (
          <option key={device.deviceId} value={device.deviceId}>
            {device.deviceId}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DeviceSelector;






